import {ApolloClient, InMemoryCache} from '@apollo/client';
import getClientEnv from '@mgp-fe/shared/utils/env-var-resolver.ts';


const cmsClient = new ApolloClient({
	connectToDevTools: false,
	uri: getClientEnv('cmsGraphqlUrl') as string,
	cache: new InMemoryCache(),
});

export default cmsClient;